import React from "react";

const LastCallTime = ({ callTime }) => {
    const formatTime = (seconds) => {
        const mins = String(Math.floor(seconds / 60)).padStart(2, "0");
        const secs = String(seconds % 60).padStart(2, "0");
        return `${mins} min ${secs} sec`;
    };

    return (
        <div
            style={{
                fontFamily: "monospace",
                display: "inline-block",
                position: "relative",
                textAlign: "center",
            }}
        >
            <span
                style={{
                    visibility: "hidden",
                    position: "absolute",
                    top: 0,
                    left: 0,
                }}
            >
                00 min 00 sec
            </span>
            <span>{formatTime(callTime)}</span>
        </div>
    );
};

export default LastCallTime;
